import React from 'react';

/** Lazy ClientComputedLearningCatalog (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedLearningCatalog = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-learning-catalog' */
            './ClientComputedLearningCatalog'
        ),
);
